module.exports = __webpack_public_path__ + "img/CoolwalletBGW_new.61739979.png";